<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-04-09 16:03:12
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-03 14:10:57
 * @FilePath: /lobby/src/views/GameView.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div :key="updateKey" style="width: 100%; height: 100vh">
    <!-- <GameBack pageName="game" /> -->
    <!-- <div class="external-page" v-html="externalContent"></div> -->
    <iframe
      id="frame"
      :src="currentGameUrl"
      :class="hasCid || country != 'ET' ? 'game' : 'sport-game'"
      scrolling="yes"
      frameborder="0"
      :key="updateKey"
      v-show="showFooter"
    />
    <DhGameFooter v-if="showFooter && (hasCid || country != 'ET')" />
    <van-action-sheet v-model:show="show" :round="false" :class="showFooter ? 'popup_layer' : ''">
      <div class="content">
        <DepositView v-if="country == 'ET'" :isInGame="true" :key="depositkey" />
        <DepositViewKE v-else-if="country == 'KE'" :isInGame="true" :key="depositKeyKE" />
        <DepositViewCI v-else-if="country == 'CI'" :isInGame="true" :key="depositKeyCI" />
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import { config } from '@/common/config'
import DhGameFooter from '@/components/GameFooter.vue'
import { BUS } from '@/event/EventCenter'
import { useUserStore } from '@/stores/user'
import DepositViewCI from '@/views/DepositViewForCI.vue'
import DepositViewKE from '@/views/DepositViewForKE.vue'
import DepositView from '@/views/DepositViewForET.vue'
import { mapActions, mapState } from 'pinia'
import { useLobbyStore } from '@/stores/lobby'

export default {
  name: 'DhGameContainer',
  components: {
    DhGameFooter,
    DepositView,
    DepositViewKE,
    // UserBar,
    DepositViewCI
  },
  props: {
    hasCid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updateKey: 0,
      depositkey: 0,
      depositKeyKE: 0,
      depositKeyCI: 0,
      currentGameUrl: '',
      show: false,
      showFooter: true
    }
  },
  computed: {
    ...mapState(useUserStore, ['userInfo', 'country', 'isLogin', 'balance'])
  },
  mounted() {
    this.updateKey++
    this.$bus.$emit(BUS.FULL_SCREEN, true)
    this.$bus.$on(BUS.UPDATE_GAME, () => {
      this.show = false
      this.updateKey++
    })
    this.$bus.$on(BUS.SHOW_DEPOSIT_IN_GAME, (boo) => {
      this.show = boo
    })
    window.addEventListener('message', this.handleMessage)
    this.$bus.$on(BUS.CLOSE_DEPOSIT_IN_GAME, () => {
      this.show = false
      this.depositkey++
      this.depositKeyKE++
      const iframe = document.getElementById('frame')
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage('DEPOSIT_COMPLETE', config.selfDevelopedGameDomain)
      }
      this.$bus.$emit(BUS.FULL_SCREEN, true)
    })
    this.$bus.$on(BUS.SHOW_GAME_FOOTER, (boo) => {
      this.showFooter = boo
    })
    this.$bus.$on(BUS.BACK_IN_GAME, () => {
      this.$router.replace('/')
    })
    if (this.hasCid || this.country != 'ET') {
      this.currentGameUrl = this.$route.params.currentGameUrl + `&timestamp=${new Date().getTime()}`
    } else {
      const env = import.meta.env.VITE_APP_ENV
      const gameconfig = {
        staging: {
          ET: 10191,
          CI: 10197,
          KE: 30001, //30025
          TZ: 50040
        },
        production: {
          ET: 10021,
          CI: 20021,
          KE: 30001, //30004
          TZ: 50040,
          GH: 40040
        }
      }
      let gameId = parseInt(gameconfig[env][this.country])
      if (this.isLogin) {
        this.enterGame(gameId).then((response) => {
          this.currentGameUrl = response.url + `&timestamp=${new Date().getTime()}`
        })
      }
    }
  },
  beforeUnmount() {
    this.$bus.$emit(BUS.FULL_SCREEN, false)
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    ...mapActions(useLobbyStore, {
      enterGame: 'enterGame'
    }),
    handleMessage(event) {
      if (
        (event.origin == config.selfDevelopedGameDomain || 'https://game.megalake.games') &&
        event.data == BUS.SHOW_DEPOSIT_IN_GAME
      ) {
        this.show = true
        console.log('展示充值页面')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.game {
  display: flex;
  width: 100%;
  height: calc(100vh - 1rem);
  background-color: black;
  // margin-top: 1rem;
  padding-top: 1rem;
}

.sport-game {
  display: flex;
  width: 100%;
  height: calc(100vh - 0.7rem - var(--nav-bar-height));
  background-color: black;
  // margin-top: 1rem;
  margin-bottom: var(--nav-bar-height);
}

.content::-webkit-scrollbar,
.popup_layer::-webkit-scrollbar {
  height: 0;
  /* 隐藏滚动条，但保持滚动功能 */
  display: none;
}

.popup_layer {
  -ms-overflow-style: none;
  width: 100%;
  height: 100%;

  // padding-top: -calc(var(--user-bar-height) + var(--user-bar-height)) !important;
  .content {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100vh;
    -ms-overflow-style: none;
  }
}
</style>
